import React from 'react';
import ReactDOM from 'react-dom';
import { Catalog, pageLoader } from 'catalog';

import AccordionMarkup from './accordion/accordion-markup';
import Stage from './stage/stage';
import stageKhMarkup from './stage/stage-kh-markup';
import LocationtoolStage from './locationtool/locationtoolStage';
import RoutingTool from './routingTool/routingTool';
import SustainabilityWidget from './sustainabilityWidget/sustainabilityWidget';
import CustomSelect from './forms/customSelect';

const pages = [
  {
    path: "/",
    title: "Welcome",
    content: pageLoader(() => import("./WELCOME.md"))
  },
  {
    title: "Foundation",
    pages: [
      {
        title: "Colours",
        path: "/colours",
        content: pageLoader(() => import("./colours.md"))
      },
      {
        title: "Favicon",
        path: "/favicon",
        content: pageLoader(() => import("./favicon.md"))
      },
      {
        title: "Flags",
        path: "/flags",
        content: pageLoader(() => import("./flags/flags.js"))
      },
      {
        title: "Icons",
        path: "/icons",
        content: pageLoader(() => import("./icons/icons.js"))
      },
      {
        title: "Images",
        path: "/images",
        content: pageLoader(() => import("./images.md"))
      },
      {
        title: "Videos",
        path: "/videos",
        content: pageLoader(() => import("./videos.md"))
      },
      {
        title: "Typography",
        path: "/typography",
        content: pageLoader(() => import("./typography.md"))
      },
      {
        title: "Grid",
        path: "/grid",
        content: pageLoader(() => import("./grid.md"))
      },
      {
        title: "Developer Info",
        path: "/developer-infos",
        content: pageLoader(() => import("./developer-infos.md"))
      },
    ]
  },
  {
    title: "Components",
    pages: [
      {
        title: "Accordion",
        path: "/accordion",
        content: pageLoader(() => import('./accordion.md')),
        imports: { AccordionMarkup: AccordionMarkup }
      },
      {
        title: "Author",
        path: "/author",
        content: pageLoader(() => import("./author.md"))
      },
      {
        title: "Back To Top",
        path: "/backToTop",
        content: pageLoader(() => import("./backToTop/backToTop.js"))
      },
      {
        title: "Breakers",
        path: "/breakers",
        content: pageLoader(() => import("./breakers.md"))
      },
      {
        title: "Breadcrumb",
        path: "/breadcrumb",
        content: pageLoader(() => import("./breadcrumb.md"))
      },
      {
        title: "Buttons",
        path: "/buttons",
        content: pageLoader(() => import("./buttons.md"))
      },
      {
        title: "Chart",
        path: "/chart",
        content: pageLoader(() => import("./chart.md"))
      },
      {
        title: "Contact",
        path: "/contact",
        content: pageLoader(() => import("./contact.md"))
      },
      {
        title: "Dialog",
        path: "/dialog",
        content: pageLoader(() => import("./dialog.md"))
      },
      {
        title: "Disclaimer",
        path: "/disclaimer",
        content: pageLoader(() => import("./disclaimer.md"))
      },
      {
        title: "Download Types",
        path: "/downloadTypes",
        content: pageLoader(() => import("./downloadTypes.md"))
      },
      {
        title: "Feedback",
        path: "/feedback",
        content: pageLoader(() => import("./feedback.md"))
      },
      {
        title: "Floating Share Bar",
        path: "/floating-bar",
        content: pageLoader(() => import("./floating-bar.md"))
      },
      {
        title: "Footer",
        path: "/footer",
        content: pageLoader(() => import("./footer.md"))
      },
      {
        title: "Header",
        path: "/header",
        content: pageLoader(() => import("./header.md"))
      },
      {
        title: "Homepage Notification",
        path: "/homepage-notification",
        content: pageLoader(() => import("./homepage-notification.md"))
      },
      {
        title: "Image Carousel",
        path: "/image-carousel",
        content: pageLoader(() => import("./image-carousel.md"))
      },
      {
        title: "Language Selector",
        path: "/language-selector",
        content: pageLoader(() => import("./language-selector.md"))
      },
      {
        title: "Link List",
        path: "/link-list",
        content: pageLoader(() => import("./link-list.md"))
      },
      {
        title: "Logo",
        path: "/logo",
        content: pageLoader(() => import("./logo.md"))
      },
      {
        title: "Modal",
        path: "/modal",
        content: pageLoader(() => import("./modal.md"))
      },
      {
        title: "Number",
        path: "/number",
        content: pageLoader(() => import("./number.md"))
      },
      {
        title: "Page Scroll Progress",
        path: "/page-scroll-progress",
        content: pageLoader(() => import("./page-scroll-progress.md"))
      },
      {
        title: "Pagination",
        path: "/pagination",
        content: pageLoader(() => import("./pagination.md"))
      },
      {
        title: "Parallax",
        path: "/parallax",
        content: pageLoader(() => import("./parallax.md"))
      },
      {
        title: "Homepage Quicklinks",
        path: "/pagequicklinks",
        content: pageLoader(() => import("./page-quicklinks.md"))
      },
      {
        title: "Picto Richtext",
        path: "/picto-richtext",
        content: pageLoader(() => import("./picto-richtext.md"))
      },
      {
        title: "Promo",
        path: "/promo",
        content: pageLoader(() => import("./promo.md"))
      },
      {
        title: "Quotation",
        path: "/quotation",
        content: pageLoader(() => import("./quotation.md"))
      },
      {
        title: "Reading Time",
        path: "/reading-time",
        content: pageLoader(() => import("./reading-time.md"))
      },
      {
        title: "Routing Tool",
        path: "/routing-tool",
        content: pageLoader(() => import("./routing-tool.md")),
        imports: { RoutingTool: RoutingTool }
      },
      {
        title: "Share",
        path: "/share",
        content: pageLoader(() => import("./share.md"))
      },
      {
        title: "Stage",
        path: "/stage",
        content: pageLoader(() => import("./stage.md")),
        imports: { Stage: Stage, StageKHMarkup: stageKhMarkup }
      },
      {
        title: "Stage Bubbles",
        path: "/stage-bubbles",
        content: pageLoader(() => import("./stage-bubbles.md"))
      },
      {
        title: "Stage - Article Variant",
        path: "/stage-article",
        content: pageLoader(() => import("./stage-article.md"))
      },
      {
        title: "Stage Headline",
        path: "/stage-headline",
        content: pageLoader(() => import("./stage-headline.md"))
      },
      {
        title: "Story",
        path: "/story",
        content: pageLoader(() => import("./story.md"))
      },
      {
        title: "Tables",
        path: "/table",
        content: pageLoader(() => import("./table/table.js"))
      },
      {
        title: "Tabs",
        path: "/tabs",
        content: pageLoader(() => import("./tabs.md"))
      },
      {
        title: "Teasers",
        path: "/teaser",
        content: pageLoader(() => import("./teaser.md"))
      }
    ]
  },
  {
    title: "Integrations",
    pages: [
      {
        title: "Chatbot",
        path: "/chatbot",
        content: pageLoader(() => import("./chatbot/chatbot.js"))
      },
      {
        title: "Site Search",
        path: "/site-search",
        content: pageLoader(() => import("./site-search.md"))
      }
    ]
  },
  {
    title: "React Apps",
    pages: [
      {
        title: "Article List",
        path: "/news-release",
        content: pageLoader(() => import("./article-list.md"))
      },
      {
        title: "Carbon Footprint Calculator",
        path: "/carbon-footprint-calculator",
        content: pageLoader(() => import("./carbon-footprint-calculator.md"))
      },
      {
        title: "Job Search",
        path: "/job-search",
        content: pageLoader(() => import("./job-search.md"))
      }
    ]
  },
  {
    title: "Utilities",
    pages: [
      {
        title: "Alignment",
        path: "/alignment",
        content: pageLoader(() => import("./alignment.md"))
      },
      {
        title: "Anchor Link",
        path: "/anchor-link",
        content: pageLoader(() => import("./anchor-link.md"))
      },
      {
        title: "Animate",
        path: "/animate",
        content: pageLoader(() => import("./animate.md"))
      },
      {
        title: "Colour Classes",
        path: "/colours_classes",
        content: pageLoader(() => import("./colours_classes.md"))
      },
      {
        title: "Content Classes",
        path: "/content_classes",
        content: pageLoader(() => import("./content-classes.md"))
      },
      {
        title: "Dark Theme",
        path: "/dark",
        content: pageLoader(() => import("./dark.md"))
      },
      {
        title: "Hyphenation",
        path: "/text",
        content: pageLoader(() => import("./text.md"))
      },
      {
        title: "Lazy Loading",
        path: "/lazy",
        content: pageLoader(() => import("./lazy.md"))
      },
      {
        title: "Loader Animation",
        path: "/loader",
        content: pageLoader(() => import("./loader.md"))
      },
      {
        title: "Spacing",
        path: "/spacing",
        content: pageLoader(() => import("./spacing.md"))
      },
      {
        title: "Text Sharing",
        path: "/text-sharing",
        content: pageLoader(() => import("./text-sharing.md"))
      },
      {
        title: "Zcroller",
        path: "/zcroller",
        content: pageLoader(() => import("./zcroller.md"))
      }
    ]
  },
  {
    title: "Widgets",
    pages: [
      {
        title: "Animated Chart",
        path: "/animated-chart",
        content: pageLoader(() => import("./animated-chart.md"))
      },
      {
        title: "Calculator",
        path: "/calculator",
        content: pageLoader(() => import("./calculator.md"))
      },
      {
        title: "Challenge Progress",
        path: "/challenge-progress",
        content: pageLoader(() => import("./challenge-progress.md"))
      },
      {
        title: "Challenge Progress Cards",
        path: "/challenge-progress-cards",
        content: pageLoader(() => import("./challenge-progress-cards.md"))
      },
      {
        title: "Contact Finder",
        path: "/contact-finder",
        content: pageLoader(() => import("./contact-finder.md"))
      },
      {
        title: "Countdown",
        path: "/countdown",
        content: pageLoader(() => import("./countdown.md"))
      },
      {
        title: "Count-up Counter",
        path: "/count-up",
        content: pageLoader(() => import("./count-up.md"))
      },
      {
        title: "Custom Sharing",
        path: "/custom-sharing",
        content: pageLoader(() => import("./custom-sharing.md"))
      },
      {
        title: "Directors Board",
        path: "/directorsboard",
        content: pageLoader(() => import("./directorsboard.md"))
      },
      {
        title: "Feedback",
        path: "/feedback-widget",
        content: pageLoader(() => import("./feedback-widget.md")),
        styles: ['/css/feedback_css.css']
      },
      {
        title: "Four Things",
        path: "/four-things",
        content: pageLoader(() => import("./four-things.md"))
      },
      {
        title: "Group Management",
        path: "/groupmanagement",
        content: pageLoader(() => import("./groupmanagement.md"))
      },
      {
        title: "Image Gallery",
        path: "/image-gallery",
        content: pageLoader(() => import("./image-gallery.md"))
      },
      {
        title: "Lazy Playing Video",
        path: "/lazy-playing-video",
        content: pageLoader(() => import("./lazy-playing-video.md"))
      },
      {
        title: "Location Tool",
        path: "/location-tool",
        content: pageLoader(() => import("./location-tool.md")),
        imports: { LocationtoolStage: LocationtoolStage }
      },
      {
        title: "Number Chart",
        path: "/number-chart",
        content: pageLoader(() => import("./number-chart.md"))
      },
      {
        title: "Number Chart Grid",
        path: "/number-chart-grid",
        content: pageLoader(() => import("./number-chart-grid.md"))
      },
      {
        title: "Number Highlight",
        path: "/number-highlight",
        content: pageLoader(() => import("./number-highlight.md"))
      },
      {
        title: "Quiz",
        path: "/quiz",
        content: pageLoader(() => import("./quiz.md"))
      },
      {
        title: "Quiz Cards",
        path: "/quiz-cards",
        content: pageLoader(() => import("./quiz-cards.md"))
      },
      {
        title: "Story Slider",
        path: "/carousel",
        content: pageLoader(() => import("./carousel.md"))
      },
      {
        title: "Storywheel",
        path: "/storywheel",
        content: pageLoader(() => import("./storywheel.md"))
      },
      {
        title: "Sustainability Widget",
        path: "/sustainability-widget",
        content: pageLoader(() => import("./sustainability-widget.md")),
        imports: { SustainabilityWidget: SustainabilityWidget }
      },
      {
        title: "Sustainability Highlight",
        path: "/sustainability-highlight",
        content: pageLoader(() => import("./sustainability-highlight.md"))
      },
      {
        title: "Tabbed Story Slider",
        path: "/tabbed-story-slider",
        content: pageLoader(() => import("./tabbed-story-slider.md"))
      },
      {
        title: "Tab Navigation",
        path: "/tab-navigation",
        content: pageLoader(() => import("./tab-navigation.md"))
      },
      {
        title: "Timeline",
        path: "/Timeline",
        content: pageLoader(() => import("./timeline.md"))
      },
      {
        title: "Total Number Counter",
        path: "/total-number-counter",
        content: pageLoader(() => import("./total-number-counter.md"))
      },
      {
        title: "ZIC Map",
        path: "/zic-chart",
        content: pageLoader(() => import("./zic-chart.md"))
      }
    ]
  },
  {
    title: "Forms",
    pages: [
      {
        title: "Forms Generator",
        path: "/forms-generator",
        content: pageLoader(() => import("./forms.md"))
      },
      {
        title: "Textfield",
        path: "/textfield",
        content: pageLoader(() => import("./forms/textfield.md"))
      },
      {
        title: "Textarea",
        path: "/textarea",
        content: pageLoader(() => import("./forms/textarea.md"))
      },
      {
        title: "Checkbox",
        path: "/checkbox",
        content: pageLoader(() => import("./forms/checkbox.md"))
      },
      {
        title: "Radio",
        path: "/radio",
        content: pageLoader(() => import("./forms/radio.md"))
      },
      {
        title: "Range Slider",
        path: "/range-slider",
        content: pageLoader(() => import("./forms/range-slider.md"))
      },
      {
        title: "Select",
        path: "/select",
        content: pageLoader(() => import("./forms/select.md")),
        imports: { CustomSelect: CustomSelect }
      }
    ]
  },
];

const styles = [
  '/css/bootstrap-grid.css',
  '/css/core.css',
  '/css/main.css',
  '/css/z-styleguide.css',
  '/css/brightcove_css.css',
  '/css/splide-core_css.css',
  '/css/calculator_css.css',
  '/css/challengeprogress_css.css',
  '/css/contactfinder_css.css',
  '/css/countdown_css.css',
  '/css/countup_css.css',
  '/css/customsharing_css.css',
  '/css/featuredarticles_css.css',
  '/css/featuredvideo_css.css',
  '/css/fourthings_css.css',
  '/css/imagegallery_css.css',
  '/css/locationtool_css.css',
  '/css/number_css.css',
  '/css/numberchart_css.css',
  '/css/numberchartgrid_css.css',
  '/css/numberhighlight_css.css',
  '/css/quiz_css.css',
  '/css/quotation_css.css',
  '/css/sitesearch_css.css',
  '/css/storywheel_css.css',
  '/css/tabnavigation_css.css',
  '/css/timeline_css.css',
  '/css/totalnumbercounter_css.css',
  '/css/sustainabilityhighlight_css.css',
  '/css/videolist_css.css',
  '/css/zicchart_css.css'
];

const theme = {
  pageHeadingBackground: "#2167ae",
  pageHeadingHeight: "106",
  fontFamily: "'ZurichSans-Light', sans-serif",
  fontHeading: "'ZurichSans-Light', sans-serif",
  fontMono: "'Roboto Mono', monospace",
  sidebarColorText: "#5495cf",
  sidebarColorTextActive: "#2167ae",
  background: '#ffffff',
  textColor: '#23366f',
  linkColor: "#1fb1e6",
  navBarBackground: "#dae2f4",
  navBarTextColor: "#23366f",
};

const logoSrc = '/images/zurich-logo-big-blue.svg';

const responsiveSizes = [
  { name: 'desktop', width: 1280, height: 720 },
  { name: 'tablet landscape', width: 1024, height: 768 },
  { name: 'tablet portrait', width: 768, height: 1024 },
  { name: 'mobile landscape', width: 667, height: 375 },
  { name: 'mobile portrait', width: 375, height: 667 },
];

ReactDOM.render(
  <Catalog title="ZXA - Zurich Experience Accelerator" pages={pages} theme={theme} styles={styles}
           logoSrc={logoSrc} responsiveSizes={responsiveSizes} />,
  document.getElementById('catalog')
);



// WEBPACK FOOTER //
// ./catalog/index.js